import {create} from 'zustand';
import {SolusPortalUrlStore} from './types';

const useSolusPortalUrlStore = create<SolusPortalUrlStore>(set => ({
	solusPortalUrl: undefined,
	setSolusPortalUrl: value => set({solusPortalUrl: value}),
}));

export {useSolusPortalUrlStore};
